module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancy":"Job","salary":"Salary","city":"City"}}')
  delete Component.options._Ctor
}
